import AccessRightList from "@src/views/components/access-rights/Page-component/AccessRightList";
import ClientForm from "@src/views/components/clients/client-form/ClientForm";
import AdminLayoutTemplate from "@src/views/layouts/AdminLayout";
import CustomLayout from "@src/views/layouts/admin-layout/CustomLayout";
import BulkSubjectUpload from "@src/views/pages/BulkSubjectUpload";
import ClientKit from "@src/views/pages/ClientKit";
import Clients from "@src/views/pages/Clients";
import Dashboard from "@src/views/pages/Dashboard";
import Devices from "@src/views/pages/devices";
import Home from "@src/views/pages/Home";
import Kits from "@src/views/pages/Kits";
import Login from "@src/views/pages/login";
import MyAccount from "@src/views/pages/MyAccount";
import Notifications from "@src/views/pages/Notifications";
import Report from "@src/views/pages/Report";
import Roles from "@src/views/pages/Roles";
import SLA from "@src/views/pages/Sla";
import SubjectDetails from "@src/views/pages/SubjectDetails";
import Subject from "@src/views/pages/subjects";
import Workers from "@src/views/pages/Workers";

const myRoutes = [
  {
    path: "login",
    name: "Login",
    component: <Login />,
    authenticate: false,
    key: "Login",
  },
  {
    path: "",
    name: "Login",
    component: <Login />,
    authenticate: false,
    key: "Login",
  },
  {
    path: "",
    name: "",
    component: <AdminLayoutTemplate />,
    children: [
      // {
      //   path: "account",
      //   name: "account",
      //   component: <MyAccount />,
      //   authenticate: false,
      //   key: "Account",
      // },
      {
        path: "home",
        name: "Home",
        component: <Home />,
        authenticate: true,
        key: "Subject Reading Dashboard",
      },
      {
        path: "details/:id",
        name: "details",
        component: <SubjectDetails />,
        authenticate: true,
        key: "Subject Reading Details",
      },
      {
        path: "on-board-analysis",
        name: "on-board-analysis",
        component: <Dashboard />,
        authenticate: true,
        key:"Subject Reading Dashboard"
      },
    ],
  },
  {
    path: "/settings",
    name: "settings",
    component: <AdminLayoutTemplate />,
    children: [
      {
        path: "account",
        name: "account",
        component: <MyAccount />,
        authenticate: true,
        key: "Account",
      },
      {
        path: "sla",
        name: "sla",
        component: <SLA />,
        authenticate: true,
        key: "Sla",
      },
      {
        path: "bulk-upload",
        name: "bulk-upload",
        component: <BulkSubjectUpload />,
        authenticate: true,
        key: "Bulk Upload",
      },
      {
        path: "notifications",
        name: "notifications",
        component: <Notifications />,
        authenticate: true,
        key: "Notifications",
      },

      {
        path: "access-rights",
        name: "Access Rights",
        component: <AccessRightList />,
        authenticate: true,
        key: "Access Rights",
      },
      {
        path: "client/:id?",
        name: "clients",
        component: <ClientForm />,
        authenticate: true,
        key: "Clients",
      },
    ],
  },
  {
    path: "/settings",
    name: "settings",
    component: <CustomLayout />,
    children: [
      {
        path: "clients",
        name: "clients",
        component: <Clients />,
        authenticate: true,
        key: "Clients",
      },

      {
        path: "devices",
        name: "devices",
        component: <Devices />,
        authenticate: true,
        key: "Devices",
      },
      {
        path: "org/:id?",
        name: "workers",
        component: <Workers />,
        authenticate: true,
        key: "Child Organization",
      },
      {
        path: "subjects",
        name: "Subjects",
        component: <Subject />,
        authenticate: true,
        key: "Subjects",
      },
      {
        path: "kits",
        name: "kits",
        component: <Kits />,
        authenticate: true,
        key: "Kits",
      },
      {
        path: "roles",
        name: "roles",
        component: <Roles />,
        authenticate: true,
        key: "Roles",
      },
      {
        path: "report",
        name: "report",
        component: <Report />,
        authenticate: true,
        key: "Report",
      },
      {
        path: "client-kits/:id/:grp_id?",
        name: "client-kits",
        component: <ClientKit />,
        authenticate: true,
        key: "Clients",
      },
    ],
  },
];
export default myRoutes;
